import { axiosProvider } from '@/app/core/axios';
import {
  getShortNameForProductToLower,
  InputFileUploadApiResponse,
} from '@ssar-app/domain';

export const uploadInputFile = (
  productName: string,
  formData: FormData,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalConfig: Record<string, any>,
): Promise<InputFileUploadApiResponse> => {
  // let reqPath = 'ascend-quest';
  // switch (product) {
  //   case ProductNameEnum.AscendArchives:
  //     reqPath = 'ascend-archives';
  //     break;
  // }
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .post<InputFileUploadApiResponse>(
        `/program/${getShortNameForProductToLower(
          productName,
        )}/input-file-upload`,
        formData,
        additionalConfig,
      )
      .then((response) => {
        // if (response?.data) {
        //   resolve(response.data);
        // }
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
